// ** React Imports
import { useHistory } from "react-router-dom";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import Block from "components/layout/Block";
import SelectorSelectSingle from "components/layout/DropdownSelectors/SelectorSelectSingle";

// ** Utils & Helpers
import generatePath from "utils/generatePath";

// #####################################################

const MessageTypeSelector = ({ filter, path }) => {
	const { t } = useTranslation("userpanel", "common");

	const history = useHistory();

	const {
		items: filterItems,
		selected: filterSelected,
		setSelected: filterSetSelected,
		compute: filterCompute,
	} = filter || {};

	// #####################################################

	return (
		<Block flex>
			<SelectorSelectSingle
				label={t("filtersAndSelectors:filterLabel")}
				emptyText={t("common:selectAll2")}
				items={filterItems}
				selected={filterSelected || "any"}
				onAccept={(value) => {
					if (
						value === null &&
						(filterSelected === "any" || filterSelected === null)
					) {
						return;
					}
					filterSetSelected(value);
					const nextUrl = generatePath(path, {
						page: 1,
						filter: filterCompute.valueToUrl(value),
					});
					history.push(nextUrl);
				}}
				withMobileVersion
				activatorStyleOptions={{ boldOnEmpty: true }}
			/>
		</Block>
	);
};

// #####################################################

export default MessageTypeSelector;

// #####################################################
